import { svg } from "lit";
const icon = svg `<path d="M24 20C24 22.2091 22.2091 24 20 24C17.7909 24 16 22.2091 16 20C16 17.7909 17.7909 16 20 16C22.2091 16 24 17.7909 24 20Z" fill="currentColor"/>`;
export default icon;
